import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getExchangeTopTradersApi } from '@flipster/apis/v1/exchange';
import { TopTraderOpenPosition } from '@flipster/apis/v1/exchange/types';
import { getAbTestApi } from '@flipster/apis/v1/user';
import { authBunja } from '@flipster/features/src/shared/auth/state';
import { snapshotSpecBunja } from '@flipster/features/src/shared/snapshot/state';
import { timestampToDate } from '@flipster/utils/datetime';

export interface TopTraderOpenPositionWithSymbol {
  position: TopTraderOpenPosition;
  pricePrecision: number;
  openedAt: Date;
}
export const topTraderOpenPositionsBunja = bunja(() => {
  const { isLoggedInAtom } = bunja.use(authBunja);
  const { instrumentsKeyBySymbolAtom } = bunja.use(snapshotSpecBunja);
  const getTopTradersApiAtom = atomWithQuery(() => {
    return {
      queryKey: ['getExchangeTopTradersApi'],
      queryFn: getExchangeTopTradersApi,
      refetchInterval: 60 * 1000,
    };
  });
  const openPositionsAtom = atom<TopTraderOpenPositionWithSymbol[]>((get) => {
    const { data } = get(getTopTradersApiAtom);
    const instrumentsKeyBySymbol = get(instrumentsKeyBySymbolAtom);
    if (!instrumentsKeyBySymbol) return [];
    const openPositions = data?.data.openPositions ?? [];
    return openPositions.map((position) => {
      const instrument = instrumentsKeyBySymbol[position.symbol];
      return {
        position,
        pricePrecision: instrument?.pricePrecision,
        openedAt: timestampToDate(position.openedAt),
      };
    });
  });
  const abTestBaseAtom = atomWithQuery((get) => ({
    queryKey: ['abTest', get(isLoggedInAtom)],
    queryFn: getAbTestApi,
  }));
  const landingTestAtom = atom((get) => get(abTestBaseAtom).data?.data.topTraderOpenPositionLanding);
  const temporalFeatureFlagAtom = atom((get) => {
    const { data } = get(getTopTradersApiAtom);
    return !data?.data.openPositions;
  });
  return { openPositionsAtom, landingTestAtom, temporalFeatureFlagAtom };
});
topTraderOpenPositionsBunja.debugLabel = 'topTraderOpenPositionsBunja';
